<template>
    <div v-if="documentos.length" class="ai-refs">
        <span class="ai-refs__label">
            <i :class="hasExternal ? 'bi-globe2' : 'bi-paperclip'" aria-hidden="true"></i>
            {{ hasExternal ? 'Pesquisa externa' : 'Consultado' }}
        </span>
        <component :is="doc.url ? 'a' : 'span'" v-for="doc in visibleDocuments" :key="doc.key" class="ai-refs__chip"
            :href="doc.url || null" :target="doc.url ? '_blank' : null" :rel="doc.url ? 'noopener noreferrer' : null"
            :title="doc.tooltip">
            <i :class="doc.icone" aria-hidden="true"></i>
            <span>{{ doc.nome }}</span>
            <small v-if="doc.fonte">{{ doc.fonte }}</small>
            <b v-if="doc.total > 1">{{ doc.total }}</b>
        </component>
        <button v-if="hiddenCount" type="button" class="ai-refs__more" @click="expanded = !expanded">
            {{ expanded ? 'Mostrar menos' : `+${hiddenCount} fontes` }}
        </button>
    </div>
</template>

<script>
const ICONES = {
    knowledge: 'bi-file-earmark-text',
    project_history: 'bi-clock-history',
    comparable_projects: 'bi-diagram-3',
    organization: 'bi-building',
    organization_profile: 'bi-building',
    external: 'bi-globe2',
}

export default {
    name: 'AssistantSources',
    data: () => ({ expanded: false }),
    props: {
        sources: { type: Array, default: () => [] },
    },
    computed: {
        hasExternal() {
            return this.documentos.some((doc) => doc.external)
        },
        visibleDocuments() {
            return this.expanded ? this.documentos : this.documentos.slice(0, 3)
        },
        hiddenCount() {
            return this.expanded ? 0 : Math.max(0, this.documentos.length - 3)
        },
        documentos() {
            const agrupados = new Map()
            this.sources.forEach((source) => {
                const grouped = Array.isArray(source?.references)
                const nome = source.title || source.name || source.source_ref || 'Fonte interna'
                const identity = source.document_id || source.project_id || source.profile_id || ''
                const key = grouped
                    ? `${source.source_type || 'fonte'}::${identity || nome}`
                    : `${source.source_type || 'fonte'}::${nome}`
                const refs = grouped ? source.references : []
                const counted = Number(source.result_count)
                const total = grouped
                    ? (Number.isFinite(counted) && counted > 0 ? counted : Math.max(refs.length, 1))
                    : 1
                const firstRef = refs.find((item) => item?.url) || refs[0] || {}
                const atual = agrupados.get(key)
                if (atual && !grouped) {
                    atual.total += 1
                    return
                }
                agrupados.set(key, {
                    key,
                    nome,
                    total,
                    url: firstRef.url || source.url || '',
                    icone: ICONES[source.source_type] || 'bi-journal-text',
                    tooltip: firstRef.excerpt || source.excerpt || source.snippet || source.content || nome,
                    external: source.source_type === 'external' || /^https?:\/\//i.test(firstRef.url || source.url || ''),
                    fonte: this.domain(firstRef.url || source.url || ''),
                })
            })
            return [...agrupados.values()]
        },
    },
    methods: {
        domain(url) {
            try {
                return url ? new URL(url).hostname.replace(/^www\./, '') : ''
            } catch {
                return ''
            }
        },
    },
}
</script>

<style scoped>
.ai-refs { display: flex; flex-wrap: wrap; gap: 0.3rem; align-items: center; margin: 0 0 1rem 2.45rem; }
.ai-refs__label { display: inline-flex; gap: 0.25rem; align-items: center; color: #98a2b3; font-size: 0.68rem; font-weight: 700; }
.ai-refs__chip { display: inline-flex; max-width: 14rem; gap: 0.3rem; align-items: center; padding: 0.2rem 0.5rem; border: 1px solid #eaecf0; border-radius: 99px; background: #fff; color: #475467; font-size: 0.7rem; text-decoration: none; }
.ai-refs__chip i { flex: 0 0 auto; color: #6941c6; font-size: 0.72rem; }
.ai-refs__chip span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ai-refs__chip small { color: #98a2b3; font-size: 0.62rem; white-space: nowrap; }
.ai-refs__chip b { flex: 0 0 auto; padding: 0 0.28rem; border-radius: 99px; background: #eef2ff; color: #4f46e5; font-size: 0.62rem; }
a.ai-refs__chip:hover { border-color: #c3b5fd; color: #4f46e5; }
.ai-refs__more { padding: 0.2rem 0.45rem; border: 0; background: transparent; color: #4f46e5; cursor: pointer; font-size: 0.68rem; font-weight: 700; }
</style>
